<mat-form-field class="lims-dropdown" appearance="outline" #singleSelect [ngClass]="class">
    <mat-label *ngIf="label">{{ label }}</mat-label>
    <mat-select  placeholder="{{ placeholder }}" [formControl]="formControl" [multiple]="multiple">
        <mat-option>
            <ngx-mat-select-search [formControl]="selectFilterCtrl" [placeholderLabel]="placeholder"
                [noEntriesFoundLabel]="noEntriesFoundLabel"></ngx-mat-select-search>
        </mat-option>
        <mat-option value="null" *ngIf="allItemLabel" (click)="changeValue()" [disabled]="disableAllItem">{{ allItemLabel }}</mat-option>
        <mat-option *ngFor="let select of filteredselects | async" [value]="select[keyId]" (click)="changeValue()">
            {{ select[keyName] }}
        </mat-option>
    </mat-select>
    <mat-error *ngIf="error" [innerHtml]="error"></mat-error>
</mat-form-field>
